import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'translate'
})
export class TranslatePipe implements PipeTransform {
    
    transform(key : string, list : Map<string, string>) {
        if (list && list.get(key)) {
            return list.get(key);
        } else {
            return key;
        }
    }
}